import axios from 'axios';

const baseDomain = process.env.VUE_APP_BASE_PATH;
const baseUrl = `${baseDomain}`;

export default axios.create({
    baseURL : baseUrl,
    withCredentials: true
});
